<template>
    <div>
        <LayerSwitcherComponent v-if="baseLayers" :layers="baseLayers" @toggle-layer="toggleLayer" />
        <main class="mapContainer" ref="mapNode"></main>
    </div>
</template>

<style>

.mapContainer {
	height: 100vh;
	width: 100%;
	position: relative;
	background: #f0f0f0;
}

#graphContainer {
	left: 2vw;
	top: 240px;
	background: white;
	width: 58vw;
	height: auto;
	min-height: 320px; /* Optional: Minimum height */
 	min-width: 600px;
	cursor: auto;
}

.chart-container {
  width: 100%;   /* Occupy full width */
  height: auto;  /* Automatically adjust height */
  min-height: 300px; /* Optional: Minimum height */
  min-width: 350px;
  position: relative;
}

.chart-container svg {
  width: 100% !important; /* Force SVG to use 100% width */
  height: auto;           /* Automatically scale height */
}

th {
	text-align: end;
}

th,
td {
	padding: 2px 4px;
}

.legend-container {
  position: absolute;
  top: 152px;
  right: 0;
  max-width: 20rem;
  height: auto;
  transition: transform 0.3s ease-in-out;
  transform: translateX(100%); /* Initially hidden to the right */
  z-index: 10;
}

.legend-container.legend-open {
  transform: translateX(0); /* Slide into view */
}

.legend-toggle {
  position: absolute;
  left: -2rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0.5rem;
  cursor: pointer;
  z-index: 11;
}


.legend-content {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 1rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  cursor: auto;
}

.legend-section {
  margin-bottom: 1rem;
}

.legend-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.color-box {
  width: 20px;
  height: 20px;
  border: 1px solid #333;
  border-radius: 2px;
}

.legend-gradient {
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.legend-values {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}

#infrastructureSection {
	display: flex;
	justify-content: space-around;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 0rem 0.94rem;
	cursor: auto;
}


.infoIcon {
    display: inline-block;
    cursor: pointer;
    margin-left: 5px;
    font-size: 12px;
    color: #007bff; /* Choose the color you like */
}

.floatingList {
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border: 1px solid #ddd;
    z-index: 10;
	white-space: nowrap;
    display: none;
}

.floatingList li {
    padding: 5px 10px;
    border-bottom: 1px solid #eee;
}

.floatingList li:last-child {
    border-bottom: none;
}


hr {
	margin: 0.2rem 0rem;
}

#legendGradient {
	height: 1rem;
}

.legendRow {
	display: flex;
}

#legendGradient {
	min-width: 300px;
}

#legendContainer svg {
	margin-right: 1rem;
}

.ol-control {
    background-color: rgba(255, 255, 255, 0.64);
    padding: 0.1rem;
}

.ol-control:hover {
    background-color: rgba(255, 255, 255, 0.75);/* Plain white, fully opaque */
}

.ol-control > button:hover,
.ol-control > div:hover {
    cursor: pointer; /* Ensure pointer behavior remains */
	transition: background-color 0.5s ease;
}

.ol-control button {
	line-height: 1rem;
}

ul,
ol {
	margin: 0.25rem 0rem;
}

#jumpContainer {
    bottom: 0rem;
    width: 30%;
    min-width: 360px;
    display: flex; /* Use flex for proper alignment */
    justify-content: space-evenly; /* Spacing between elements */
    align-items: center; /* Centers items vertically */
    background: white;
}

#jumpContainer img {
    height: 1rem;
    width: auto;
    display: block; /* Ensures proper block-level rendering */
    margin: 0 auto; /* Center the image within its container */
}

#jumpContainer a,
#jumpContainer abbr {
    display: flex; /* Ensure children are also flex-aligned */
    align-items: center; /* Center the contents inside the container */
    text-align: center; /* Optional: Center text within links */
}

#jumpContainer abbr {
    font-size: 1rem;
    color: black;
}

.ol-zoom,
.ol-zoomslider {
    top: auto;
    bottom: 1rem;
    right: 1rem;
    left: auto;
}

.ol-zoom {
    position: absolute;
    gap: 0.5rem;
}

.ol-zoomslider {
    bottom: 5rem;
}


.custom-scale-line {
  position: absolute;
  bottom: 5px;
  right: 60px;
  z-index: 10;
}

@media (max-width: 720px) {
  .custom-scale-line {
    left: 10px;
    bottom: 50px;
  }

  .ol-zoom {
    position: absolute;
	bottom: 20rem;
  }
}

.c3-axis-y-label,
.c3-axis-x-label {
	font-size: 1rem;
}

.c3-ygrid-line.thicker>line {
	stroke: red;
}

.gridCell {
    background-color: white; /* Default background color */
    transition: background-color 0.3s ease; /* Smooth transition */
	border-radius: 10px;
}

.gridCell:hover {
    background-color: #f0f0f0; /* Light gray background on hover */
}


.infrastructure-node {
    display: flex;
    flex-direction: column; /* Stack children vertically */
    align-items: center;   /* Center-align children */
    text-align: center;    /* Center text inside the container */
    margin: 5px;          /* Add some spacing between nodes */
}

.infrastructure-node .icon {
    width: 50px;   /* Adjust the width of the icon */
    height: 50px;  /* Adjust the height of the icon */
    margin-bottom: 5px; /* Add space between the icon and text */
}

.infrastructure-node .description {
    font-size: 14px; /* Adjust the font size as needed */
    color: #333;     /* Optional: Adjust text color */
}

.infrastructure-node .dropdown-indicator {
    margin-top: 2px; /* Add space above the SVG */
}

</style>

<script setup>

import proj4 from "proj4"; // proj4js tool is now just proj4


// OpenLayers imports
import { Map, View, Feature } from "ol";
import { Point, Polygon } from "ol/geom"

import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";

import { fromExtent } from "ol/geom/Polygon";

import { defaults as defaultControls, ZoomSlider, ScaleLine, FullScreen } from "ol/control";
import { defaults as defaultInteractions, Select, DoubleClickZoom } from "ol/interaction";

import { transform } from "ol/proj";
import { register } from "ol/proj/proj4"; // so no conflict between tools

// our custom extensions using OL
import { GraphControl } from "./plot-control";
import { LegendControl } from "./legend-control";
import { JumperControl } from "./jumper-control";
import { RiskSectorControl } from "./risk-sector-control";

import styleRepository from "./styles-repository";

// Finally only Vue3 imports
import { onMounted, ref } from "vue";

import { getBaseLayers } from "./baseLayers";
import LayerSwitcherComponent from "./LayerSwitcherComponent.vue";

const props = defineProps({ title: String });

const mapNode = ref(null);
const baseLayers = ref(null)

const zoomSeparator = 14;
const hitTolerance = 5;


onMounted(() => {
	proj4.defs("EPSG:3794", "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs");

	register(proj4);

	const frameSource = new VectorSource({ wrapX: false });

	const cemsenik = new Feature(fromExtent([494694, 115260, 496196, 116130]));
	const vipava = new Feature(fromExtent([418658, 69167, 425748, 77819]));
	const koroskaBela = new Feature(fromExtent([431409, 143609, 433958, 144991]));
	const savinja = new Feature(fromExtent([461972, 120430, 499540, 150994]));
	const sora = new Feature(fromExtent([393814, 83230, 458067, 122980]));

	cemsenik.set("title", "Čemšenik");
	vipava.set("title", "Vipava");
	koroskaBela.set("title", "Koroška Bela");
	savinja.set("title", "Porečje Savinje");
	sora.set("title", "Porečje Sore");

	frameSource.addFeature(cemsenik);
	frameSource.addFeature(vipava);
	frameSource.addFeature(koroskaBela);
	frameSource.addFeature(savinja);
	frameSource.addFeature(sora);

	const frameLayer = new VectorLayer({
		source: frameSource,
		style: (feature) => {
			if (mapView.getZoom() <= zoomSeparator) return styleRepository.areaStyle(feature);

			return null;
		}
	});

	const activitiesSource = new VectorSource({ wrapX: false });

	fetchActivityAreas(activitiesSource);

	const activitiesLayer = new VectorLayer({
		source: activitiesSource,
		style: (feature) => {
			if (mapView.getZoom() > zoomSeparator) return styleRepository.activityStyle(feature);

			return null;
		}
	});



	const sensorsSource = new VectorSource({ wrapX: false });

	const sensorsLayer = new VectorLayer({
		source: sensorsSource,
		style: (feature) => {
			// if (mapView.getZoom() > zoomSeparator) return styleRepository.sensorStyle(feature);

			// return null;
            return styleRepository.sensorStyle(feature);
		}
	});



	const mapView = new View({
		center: transform([14.815333, 46.119944], "EPSG:4326", "EPSG:3794"),
		extent: [310000, 20000, 690000, 210000],
		projection: "EPSG:3794",
		zoom: 0
	});



	const lineToBar = {
		minWidth: 128,
		bar: true,
		text: true
	};



	// default allows only single element of sensor layers to be selected
	const pointSelectTool = new Select({ layers: [sensorsLayer], hitTolerance : hitTolerance });

	const shapeSelectTool = new Select({
		layers: [activitiesLayer],
		style: styleRepository.selectStyle,
        hitTolerance : hitTolerance
	});

    const doubleClickZoom = new DoubleClickZoom({
        delta: 5,
        duration: 500
    });

	const graph = new GraphControl();

    baseLayers.value = getBaseLayers()

	const riskSectorControl = new RiskSectorControl()

	const theMap = new Map({
		target: mapNode.value,
		layers: [...baseLayers.value, activitiesLayer, sensorsLayer, frameLayer],
		view: mapView,
		controls: defaultControls().extend([
			new ZoomSlider(),
			new ScaleLine({
			...lineToBar,
			className: 'custom-scale-line'
			}),
			graph,
			new LegendControl(),
			new JumperControl(props.title),
			riskSectorControl,
			new FullScreen(),
		]),
		interactions: defaultInteractions({ doubleClickZoom: false }).extend([pointSelectTool, shapeSelectTool, doubleClickZoom])
	});

	// Add a cursor change on hover functionality
	theMap.on('pointermove', function (event) {
		const pixel = theMap.getEventPixel(event.originalEvent);

		// Check if a feature is under the mouse
		const hit = theMap.hasFeatureAtPixel(pixel, {
            hitTolerance : hitTolerance,
            layerFilter: function(layer) {
                return layer === sensorsLayer || layer === activitiesLayer;
            }
        });

		// Change the cursor style based on whether a feature is hit or not
		theMap.getTargetElement().style.cursor = hit ? 'pointer' : 'grab';
	});

	// Change the cursor to 'grabbing' when the user clicks to drag
	theMap.on('pointerdown', function (event) {
		const pixel = theMap.getEventPixel(event.originalEvent);
		const hit = theMap.hasFeatureAtPixel(pixel, {
            hitTolerance : hitTolerance,
            layerFilter: function(layer) {
                return layer === sensorsLayer || layer === activitiesLayer;
            }
        });

		// Only change to grabbing if not interacting with a feature
		if (!hit) {
			theMap.getTargetElement().style.cursor = 'grabbing';
		}
	});

	// Change the cursor back to 'grab' when the user releases the drag
	theMap.on('pointerup', function () {
		theMap.getTargetElement().style.cursor = 'grab';
	});

	// Handle situations where dragging is canceled (e.g., pointer leaves the map)
	theMap.on('pointerdrag', function () {
		theMap.getTargetElement().style.cursor = 'grabbing';
	});



	// it's on single-click event of the map, but it's custom made single-select by default
	pointSelectTool.on("select", (singleSelectEvent) => {
		if (singleSelectEvent.selected.length !== 1) return;

		let selectedElement = singleSelectEvent.selected[0];

		const mapElementData = selectedElement.getProperties();

		delete mapElementData.geometry;

		axios.get("api/reads/" + mapElementData.identity).then((response) => {
			if (response.status !== 200 || !response.data || !response.data.length) {
				console.error("no response or no data within. Abort");
				return;
			}

			let graphData = response.data.map((item) => {
				return { day: item.day, current: Number(item.offset) };
			});

			graph.replaceGraphValues(mapElementData, graphData);
		}).catch((error) => {
			console.error(error);
		});
	});



	shapeSelectTool.on("select", (singleSelectEvent) => {
		if (!singleSelectEvent.selected.length) { return; }

		let selectedElement = singleSelectEvent.selected[0];

		const riskZone = selectedElement.getProperties();

		riskSectorControl.replaceRiskZoneStatistic(riskZone);
	});



	// const mapMover = (singleClickEvent) => {
	// 	singleClickEvent.preventDefault();
	// 	singleClickEvent.stopPropagation();

	// 	const foundFeatureArray = frameSource.getFeaturesAtCoordinate(singleClickEvent.coordinate);

	// 	if (!foundFeatureArray.length) return;

	// 	mapView.animate({
	// 		center: singleClickEvent.coordinate,
	// 		zoom: 15,
	// 		duration: 500, // Duration in milliseconds
	// 	});

	// 	theMap.un("singleclick", mapMover);
	// };

	// theMap.on("singleclick", mapMover);



	let fetchTimeout;

	theMap.on("moveend", (moveEvent) => {
		const zoomLevel = mapView.getZoom();
		const viewExtent = mapView.calculateExtent();

		// if (zoomLevel < zoomSeparator) {
		// 	theMap.on("singleclick", mapMover);
		// 	return;
		// }

		clearTimeout(fetchTimeout);

		fetchTimeout = setTimeout(() => {
			fetchSensorsData(sensorsSource, viewExtent);
		}, 500);
	});
});



const fetchActivityAreas = (dumpSource) => {
	if (!dumpSource) {
		console.error("Nowhere to dump area activity level data");
		return;
	}

	axios.get("api/dangers").then((response) => {
		if (!response || response.status !== 200) {
			// well in reality we would already trigger error catch-up
			console.error("something wrong with area danger level response");
			return;
		}

		response.data.forEach((item) => {
			const mapData = Object.assign({}, item);

			const mapShape = new Polygon(item.shape.coordinates); // array to ol.Polygon

			delete mapData.shape; // remove shape from data

			const mapElement = new Feature(mapData); // make Feature without geometry part

			mapElement.setGeometry(mapShape); // now back geometry in proper format back

			dumpSource.addFeature(mapElement);
		});
	}).catch((error) => { console.error(error); });
};



const fetchSensorsData = (dumpSource, boundaryArray) => {
	if (!dumpSource || !boundaryArray || !Array.isArray(boundaryArray) || boundaryArray.length !== 4) {
		console.error("nowhere to dump sensors data");
		return;
	}

	axios.get("api/sensors/" + boundaryArray[0] + '/' + boundaryArray[1] + '/' + boundaryArray[2] + '/' + boundaryArray[3]).then((response) => {
		if (!response || response.status !== 200) {
			console.error("something wrong with sensors response");
			return;
		}

		dumpSource.clear();

		dumpSource.clear();

		response.data.forEach((item) => {
			const mapData = Object.assign({}, {
				identity: item.id,
				z: Number(item.z),
				meanAnnualOffset: Number(item.average_offset),
				longitude: item.location.coordinates[0],
				latitude: item.location.coordinates[1],
			});

			const mapShape = new Point(item.location.coordinates);

			delete mapData.location;

			const mapElement = new Feature(mapData);

			mapElement.setGeometry(mapShape);

			dumpSource.addFeature(mapElement);
		});
	}).catch((error) => { console.error(error) });
};


</script>
